export default __webpack_public_path__ + "static/media/icon-lock-color-white.29e28b95.svg";